// extracted by mini-css-extract-plugin
export default {"embeddingWrapper":"embedding_embeddingWrapper__BsICk"};